import { render, staticRenderFns } from "./contractualDetailed.vue?vue&type=template&id=5489a016&scoped=true"
import script from "./contractualDetailed.vue?vue&type=script&lang=js"
export * from "./contractualDetailed.vue?vue&type=script&lang=js"
import style0 from "./contractualDetailed.vue?vue&type=style&index=0&id=5489a016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5489a016",
  null
  
)

export default component.exports